import { REGEX, DESPOSABLE_EMAIL } from '../constant';

let disposableSet = null;

export const isDisposableEmail = (email) => {
    if (!window.location.origin?.includes("superworks.com")) return false;
    if (!email) return false;
    if (!disposableSet) {
        disposableSet = new Set(DESPOSABLE_EMAIL);
    }

    const domain = email.split('@')[1];
    if (!domain) return false;

    const parts = domain.split('.');
    for (let i = 0; i < parts.length; i++) {
        const sub = parts.slice(i).join('.');
        if (disposableSet.has(sub)) return true;
    }
    return false;
};

export function checkMinLength(value, length) {
    return value && value.length >= length
}

export function checkUppercase(value) {
    return (REGEX.upperCase.test(value));
}

export function checkLowercase(value) {
    if (value) return (REGEX.lowerCase.test(value));
    else return false
}

export function checkNumeric(value) {
    return REGEX.number.test(value)
}

export function checkSpecialCharacter(value) {
    return REGEX.specialChar.test(value)
}

export const clearValidation = (validator = {}, keys = [], allClear = false) => {
    if (validator.current && validator.current.fields && keys?.length) {
        keys?.forEach(_ => {
            validator.current.hideMessageFor(_);
            delete validator.current.errorMessages[_];
            validator.current.fields[_] = true;
        });
        validator.current.hideMessages();
    }
    if (allClear) {
        // For clear All validation,  No need To pass keys one by one
        const keys = Object?.keys(validator.current.fields)
        if (keys?.length) {
            keys?.forEach(_ => {
                validator.current.hideMessageFor(_);
                delete validator.current.errorMessages[_];
                validator.current.fields[_] = true;
            });
            validator.current.hideMessages();
        }
    }
}

export const isValidMongoId = (value) => {
  if (typeof value !== 'string') return false;

  // Quick length check (fast fail)
  if (value.length !== 24) return false;

  // Hexadecimal validation (strict)
  const hexRegex = /^[a-fA-F0-9]{24}$/;

  return hexRegex.test(value);
}

export const makeAllValid = (validator) => {
    if (validator?.current?.fields && validator?.current?.errorMessages) {
        for (const key in validator.current.errorMessages) {
            validator.current.hideMessageFor(key)
            delete validator.current.errorMessages[key]
            validator.current.fields[key] = true
        }
    }
}
